import React, { Component } from "react";
import { Translate } from "react-redux-i18n";
import Modal from "react-bootstrap/Modal";

import simpleCard from "../../../styles/images/simpleCard.svg";
import warning from "../../../styles/images/warning.svg";
import "../../../styles/components/evs/modals/RequestNetworkAccess.scss";
import "./ConfirmBlock.css";


import {
  CANCELLATION_REASONS,
} from "../../utils/Utils";

class ConfirmBlock extends Component {
    constructor(props) {
        super(props);
        this._mounted = false;
        this.cancel = null;
    }

    componentDidMount() {
        this._mounted = true;
    }

    componentWillUnmount() {
        if (this.cancel !== null) this.cancel("Component is unmounting");
        this._mounted = false;
    }

    render() {
        return (
          <Modal
            id="ConfirmBlock"
            show={this.props.show}
            onHide={this.props.onHide}
            onSuccess={this.props.onSuccess}
            dialogClassName="custom-modal-width"
            centered
          >
            <Modal.Header className="confirm-block-header">
              <div className="confirm-block-header-title">
                <img
                  src={warning}
                  alt="Aviso"
                  className="confirm-block-warning-icon"
                />
                <Modal.Title>
                  <Translate value="contractsPhysicalCard_cancelConfirmTitle" />
                </Modal.Title>
              </div>
              <button
                type="button"
                onClick={this.props.onHide}
                className="confirm-block-close-btn"
                aria-label="Fechar"
              >
                &#x2715;
              </button>
            </Modal.Header>
            <Modal.Body>
              <div>
                <div className="confirm-block-warning-box">
                  <div className="confirm-block-warning-flex">
                    <p className="confirm-block-warning-text">
                      <b>
                        <Translate value="contractsPhysicalCard_cancelConfirmWarmingMessageAtention" />
                      </b>
                      <Translate value="contractsPhysicalCard_cancelConfirmWarmingMessage" />
                    </p>
                  </div>
                </div>
                <div className="confirm-block-main-box">
                  <div className="confirm-block-main-flex">
                    <img
                      src={simpleCard}
                      alt="Card"
                      className="confirm-block-card-icon"
                    />
                    <b className="confirm-block-main-title">
                      <Translate value="contractsPhysicalCard_cancelConfirmPermanently" />
                    </b>
                  </div>
                  <hr></hr>
                  <div>
                    <div className="confirm-block-row">
                      <b>
                        <Translate value="stoppedSessionByReason_subtitle" />
                      </b>{" "}
                      <span className="confirm-block-row-value">
                        {
                          CANCELLATION_REASONS[
                            this.props?.reasons?.reason?.reason
                          ]
                        }
                      </span>
                    </div>
                    {this.props?.reasons?.reason?.description && (
                      <div className="confirm-block-row">
                        <b>
                          <Translate value="stoppedSessionByReason_description" />
                        </b>{" "}
                        <span className="confirm-block-row-value">
                          {this.props?.reasons?.reason?.description}
                        </span>
                      </div>
                    )}
                    <div className="confirm-block-row">
                      <b>
                        <Translate value="contractsPhysicalCard_cancelConfirmReplace" />
                      </b>{" "}
                      <span className="confirm-block-row-value">
                        {this.props?.replacement ? (
                          <Translate value="contractsPhysicalCard_cancelConfirmReplaceYes" />
                        ) : (
                          <Translate value="general_no" />
                        )}
                      </span>
                    </div>
                    {this.props.address !== "" && (
                      <div className="confirm-block-address-row">
                        <b>
                          <Translate value="contractsPhysicalCard_newAddress" />
                        </b>
                        <br />
                        <span className="confirm-block-row-value">
                          {this.props?.address}
                        </span>
                        <br />
                        <span className="confirm-block-row-value">
                          {this.props?.addressCode}
                        </span>
                        <br />
                        <span className="confirm-block-row-value">
                          {this.props?.addressCountry}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer className="confirm-block-footer">
              <button type="button" onClick={this.props.onHide}>
                <Translate value="confirmCancel_back" />
              </button>
              <button
                type="button"
                onClick={() => {
                  this.props.onHide();
                  this.props.onSuccess();
                }}
              >
                <Translate value="contractsPhysicalCard_cancelConfirmButton" />
              </button>
            </Modal.Footer>
          </Modal>
        );
    }
}

export default ConfirmBlock;
